export default __webpack_public_path__ + "static/banner-the-gift-that-keeps-on-giving-e5f9d2ddae59c3528667558995898730.jpg";